import { connect } from 'react-redux';
import ChangePassword from '../../components/Auth/ChangePassword';
import {
  resetPassword,
	getAPIBuildNumber
} from '../../actions/App';

function mapStateToProps(state) {
	const { loginDialog, forgotPassword, loggedIn, email, password, userId,  token, roleId, roleName,
		clients, selected_client, loginUserDetail,apiBuildNumber,
		resetPasswordSuccess, resetPasswordFailMessage } = state.app
	return {
		loginDialog,
		forgotPassword,
		email,
		password,
		loggedIn,
		userId,
		roleId,
		roleName,
		clients,
		selected_client,
		token,
		loginUserDetail,
		apiBuildNumber,
		resetPasswordSuccess,
		resetPasswordFailMessage,
		location: {
			path: state.routing.location.pathname,
			queryStep: state.routing.location.match ? state.routing.location.match.params.step : '',
			query: state.routing.location.match ? state.routing.location.match.params : null,
			search: state.routing.location.search
		}
	};
}

function mapDispatchToProps(dispatch) {
	return {
		resetPassword: (pwd, rePwd, secretKey) => {
			dispatch(resetPassword(pwd, rePwd, secretKey))
		},
		getAPIBuildNumber: () => {
			dispatch(getAPIBuildNumber());
		}
	};
}

const ChangePasswordContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ChangePassword);

export default ChangePasswordContainer;


// WEBPACK FOOTER //
// ./src/containers/Auth/ChangePassword.js